<template>
  <div
    class="sf-pad-3 sf-layer-border-bottom"
    data-walkthrough-id="chart-title-and-type"
  >
    <input
      id="graph-title"
      v-model="currentTitle"
      class="sf-form-input sf-full sf-below-2"
      :class="{ 'sf-disabled': readOnly }"
      type="text"
      :placeholder="I18n.t('js.report_graph.edit.graph_title_placeholder')"
    />
    <div
      v-show="graphErrors.title"
      class="sf-alert sf-alert-danger sf-pad-1 sf-level-vertical sf-below-2"
    >
      <div
        v-for="(errorMessage, index) in graphErrors.title"
        :key="index"
        class="sf-level-item"
      >
        {{ errorMessage }}
      </div>
    </div>
    <div class="sf-grid sf-grid-fluid">
      <div class="sf-row">
        <div class="sf-col sf-xs-6">
          <div
            id="linechart-type"
            class="sf-layer-rounded sf-align-c sf-pad-2 sf-pointer"
            :class="classFor('linechart')"
            @click="setGraphTypeTo('linechart')"
          >
            <svg
              width="28px"
              height="25px"
              viewBox="0 0 28 25"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="sf-inline-block"
            >
              <g
                id="SVG"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                stroke-linecap="round"
              >
                <g transform="translate(1.000000, 2.000000)">
                  <polyline
                    class="sf-stroke"
                    stroke-width="2.8"
                    points="5.32248521 7.35 12.4191321 3.15 16.322288 7 24.1285996 2.1"
                  />
                  <line
                    x1="0.709664694"
                    y1="0"
                    x2="0.709664694"
                    y2="21"
                    class="sf-stroke"
                    stroke-width="2.8"
                  />
                  <line
                    x1="24.8382643"
                    y1="21"
                    x2="0.709664694"
                    y2="21"
                    class="sf-stroke"
                    stroke-width="2.8"
                  />
                  <line
                    x1="5.32248521"
                    y1="12.7458333"
                    x2="5.32248521"
                    y2="15.9541667"
                    opacity="0.3"
                    class="sf-stroke"
                    stroke-width="3.5"
                  />
                  <line
                    x1="16.6771203"
                    y1="12.25"
                    x2="16.6771203"
                    y2="15.75"
                    opacity="0.3"
                    class="sf-stroke"
                    stroke-width="3.5"
                  />
                  <line
                    x1="22.3544379"
                    y1="11.55"
                    x2="22.3544379"
                    y2="15.75"
                    opacity="0.3"
                    class="sf-stroke"
                    stroke-width="3.5"
                  />
                  <line
                    x1="10.9998028"
                    y1="9.45"
                    x2="10.9998028"
                    y2="15.9478263"
                    opacity="0.3"
                    class="sf-stroke"
                    stroke-width="3.5"
                  />
                </g>
              </g>
            </svg>
            <div>{{ I18n.t('js.report_graph.graph_types.timeseries') }}</div>
          </div>
        </div>
        <div class="sf-col sf-xs-6">
          <div
            id="piechart-type"
            class="sf-layer-rounded sf-align-c sf-pad-2 sf-pointer"
            :class="classFor('piechart')"
            @click="setGraphTypeTo('piechart')"
          >
            <svg
              width="29px"
              height="28px"
              viewBox="0 0 29 28"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <rect
                  id="path-1"
                  x="0"
                  y="0"
                  width="28.0644"
                  height="27.3"
                  rx="13.416"
                />
                <mask
                  id="mask-2"
                  maskContentUnits="userSpaceOnUse"
                  maskUnits="objectBoundingBox"
                  x="0"
                  y="0"
                  width="28.0644"
                  height="27.3"
                  fill="white"
                >
                  <use xlink:href="#path-1" />
                </mask>
              </defs>
              <g
                id="SVG"
                stroke="none"
                stroke-width="0"
                fill="none"
                fill-rule="evenodd"
              >
                <g fill-rule="nonzero">
                  <use
                    class="sf-stroke"
                    opacity="0.3"
                    mask="url(#mask-2)"
                    stroke-width="28.6"
                    stroke-dasharray="0,0"
                    xlink:href="#path-1"
                  />
                  <use
                    class="sf-stroke"
                    mask="url(#mask-2)"
                    stroke-width="28.6"
                    stroke-dasharray="53.87199821472168,47.83999900817872"
                    xlink:href="#path-1"
                  />
                </g>
              </g>
            </svg>
            <div>{{ I18n.t('js.report_graph.graph_types.piechart') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="graphErrors.graphType">
      <div class="sf-below-2" />
      <div class="sf-alert sf-alert-danger sf-pad-1 sf-level-vertical">
        <div
          v-for="(errorMessage, index) in graphErrors.graphType"
          :key="index"
          class="sf-level-item"
        >
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState(['currentLocale', 'graph', 'readOnly']),
    ...mapGetters(['graphCurrentTitle', 'graphErrors']),
    currentTitle: {
      get() {
        return this.graphCurrentTitle
      },
      set(newTitle) {
        this.setCurrentTitle({ title: newTitle })
      },
    },
  },
  methods: {
    ...mapActions(['setCurrentTitle', 'setGraphType']),
    classFor(graphType) {
      return {
        'sf-bg-primary-subtle sf-c-primary': this.graph.graphType === graphType,
        'sf-bg-snow sf-c-text': this.graph.graphType !== graphType,
      }
    },
    setGraphTypeTo(graphType) {
      if (this.readOnly) {
        return
      }
      this.setGraphType({ graphType: graphType })
    },
  },
}
</script>
